import { Component, Input } from '@angular/core';
import { WorkAndRestTableEnum } from 'src/app/shared/enums/work-and-rest-table-names.enum';

@Component({
  selector: 'app-work-and-rest-templates',
  standalone: false,
  templateUrl: './work-and-rest-templates.component.html',
  styleUrl: './work-and-rest-templates.component.scss',
})
export class WorkAndRestTemplatesComponent {
  @Input() specificTemplateName: string;
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };

  WorkAndRestTableEnum = WorkAndRestTableEnum;
}
